interface MapPoint {
  id: number;
  Lat: string;
  Lng: string;
  Type: number;
}

interface MapPointData extends MapPoint {
  Code: string;
  Name: string;
  Address: string;
  City: string;
  State: string;
  Phone: string;
  Email: string;
  WWW: string;
  Description: string;
  RelatedPicture: string;
  OpenFromWeek: string;
  OpenToWeek: string;
  OpenFromSat: string;
  OpenToSat: string;
  OpenFromSun: string;
  OpenToSun: string;
}

$(window).on('load', () => {
  class DumelMap {
    private brandId: number;
    private map: google.maps.Map;
    private autocomplete: google.maps.places.Autocomplete;
    private element: JQuery;
    private activeFilterTypes: number[] = [];
    private mapMarkers: google.maps.Marker[] = [];
    private cachedMarkers: MapPoint[] = [];
    private popupElement: Popup;
    private startPosition: google.maps.LatLngLiteral;

    constructor(element) {
      this.element = element;
      this.brandId = parseInt(this.element.find('.cms-dumel-map__wrap').attr('data-brand-id'), 10);
      this.initEvents();
    }

    toggleMap() {
      this.element.find('.cms-dumel-map__wrap').toggleClass('cms-dumel-map__wrap--opened');
      $('body').toggleClass('lock-body');
      this.setMapPosition();
    }

    openResize(){
      $('.cms-dumel-map').addClass('--resize');
      $('.cms-dumel-map-resize').addClass('--resize');
      $('.cms-dumel-map__resize--left').addClass('--resize');
      $('.cms-dumel-map__resize--right').addClass('--resize');
    }

    private init() {
      this.initMap();
      this.initAutocomplete();

      this.element.find('.cms-dumel-map__shop-list').empty();
    }

    private setMapPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position: Position) => {
          this.startPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          this.init();
        }, (error: PositionError) => {
          this.startPosition = this.getDefaultPosition();
          this.init();
        });
      } else {
        this.startPosition = this.getDefaultPosition();
        this.init();
      }
    }

    private filter() {
      this.activeFilterTypes = this.getActiveFilterTypes();

      this.mapMarkers.forEach((marker) => marker.setMap(null));

      this.cachedMarkers.forEach(item => {
        if (this.activeFilterTypes.indexOf(item.Type) > -1) {
          const marker = new google.maps.Marker({
            position: {
              lat: parseFloat(item.Lat),
              lng: parseFloat(item.Lng)
            },
            animation: google.maps.Animation.DROP,
            icon: {
              scaledSize: new google.maps.Size(29, 40),
              url: this.getMarkerUrl(item.Type)
            },
            map: this.map
          });

          marker.addListener('click', (a) => {
            const position = {
              lat: a.latLng.lat(),
              lng: a.latLng.lng()
            };
            this.map.panTo(position);
            this.openResize();
            if (this.popupElement) {
              this.popupElement.setMap(null);
            }

            this.popupElement = new Popup(new google.maps.LatLng(position.lat, position.lng),
              item.Type, this.getPointContentHtml(item.id) as Promise<MapPointData>);
            this.popupElement.setMap(this.map);
          });

          this.mapMarkers.push(marker);
        }
      });
    }

    private getDefaultPosition(): google.maps.LatLngLiteral {
      return {
        lat: 52.232222,
        lng: 21.008333
      };
    }

    private initMap() {
      this.map = new google.maps.Map(this.element.find('.cms-dumel-map')[0], {
        center: this.startPosition,
        zoom: 12,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: [
          {
            featureType: 'poi',
            stylers: [
              { visibility: 'off' }
            ]
          },
          {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
          }
        ]
      });
    }

    private initAutocomplete() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.element.find('.cms-dumel-map__shop-input-element')[0] as HTMLInputElement, {
        types: ['(cities)'],
        componentRestrictions: {
          country: 'pl'
        }
      }
      );

      this.autocomplete.bindTo('bounds', this.map);

      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete.getPlace();

        if (!place.geometry) {
          return;
        }

        if (place.geometry.viewport) {
          this.map.fitBounds(place.geometry.viewport);
        } else {
          this.map.panTo(place.geometry.location);
        }
      });
    }

    private initEvents() {
      this.element.find('.cms-dumel-map__close, .cms-dumel-map__cross').click(() => {
        this.toggleMap();
      });

      this.element.find('.cms-dumel-map__filter-item').click(event => {
        $(event.delegateTarget).toggleClass(
          'cms-dumel-map__filter-item--disabled'
        );

        this.filter();
      });

      this.element.find('.cms-dumel-map__wrap').on('transitionend webkitTransitionEnd oTransitionEnd', event => {
        const eventType = (event.originalEvent as TransitionEvent).propertyName;
        if (eventType === 'transform' && $(event.target).hasClass('cms-dumel-map__wrap--opened')) {
          this.downloadAndCacheMarkers();
        }
      });
    }

    private downloadAndCacheMarkers() {
      const productCode = this.element.find('.cms-dumel-map__shop--internet').attr('data-product-id'); // tslint:disable-line

      let ajaxUrl = 'https://mapy.dumel.com.pl/api/shops/' + this.brandId;

      if (!!productCode) {
        ajaxUrl = ajaxUrl + '/' + productCode;
      }

      $.ajax({
        url: ajaxUrl,
        type: 'get',
        success: response => {
          this.cachedMarkers = response.shops;
          const internetShops = response.internetShops.map(item => {
            item.Picture = response.storage + item.Picture;

            return item;
          });
          this.buildInternetShops(internetShops);
          this.filter();
        }
      });
    }

    private buildInternetShops(internetShops) {
      const itemsArray = [];

      internetShops.forEach(item => {
        if (itemsArray.indexOf(item.Picture) >= 0) {
          return;
        }

        itemsArray.push(item.Picture);

        if (parseInt(item.Price, 10) > 0) {
          this.element.find('.cms-dumel-map__shop-list').append(`
                  <li class="cms-dumel-map__shop-item">
                    <a target="_blank" href="${item.Url}" class="cms-dumel-map__shop-item-link" rel="nofollow">
                      <div class="cms-dumel-map__shop-item-image-wrap">
                        <img class="cms-dumel-map__shop-item-image" src="${item.Picture}" />
                      </div>
                      <div class="cms-dumel-map__shop-item-href">${item.WWW}</div>
                      <div class="cms-dumel-map__shop-item-price">
                        <div class="cms-dumel-map__shop-item-price-value">${parseFloat(item.Price).toFixed(2).replace('.', ',')} zł</div>
                        <div class="cms-dumel-map__shop-item-available">Dostępny</div>
                      </div>
                    </a>
                  </li>
                `);
        } else {
          const brandUrl = item.Url ? item.Url : item.WWW;

          this.element.find('.cms-dumel-map__shop-list').append(`
                  <li class="cms-dumel-map__shop-item">
                    <a target="_blank" href="${brandUrl}" class="cms-dumel-map__shop-item-link" rel="nofollow">
                      <div class="cms-dumel-map__shop-item-image-wrap">
                        <img class="cms-dumel-map__shop-item-image" src="${item.Picture}" />
                      </div>
                      <div class="cms-dumel-map__shop-item-href">${item.WWW}</div>
                    </a>
                  </li>
                `);
        }
      });
    }

    private getActiveFilterTypes(): number[] {
      const types: number[] = [];

      this.element
        .find('.cms-dumel-map__filter-item')
        .each((filterItemIndex, filterItem) => {
          if (!$(filterItem).hasClass('cms-dumel-map__filter-item--disabled')) {
            types.push(parseInt($(filterItem).attr('data-type'), 0));
          }
        });

      return types;
    }

    private getMarkerUrl(type: number) {
      const assetsUrl = '/assets/widgets/dumel-maps/';
      const icons = {
        2: { icon: assetsUrl + 'marker_smyk.png' },
        3: { icon: assetsUrl + 'marker_ru.png' },
        4: { icon: assetsUrl + 'marker_detal.png' },
      };

      return icons[type].icon;
    }

    private getPointContentHtml(id: number) {
      const pointData = this.cachedMarkers.find(pointDataItem => pointDataItem.id === id);

      if (pointData) {
        return Promise.resolve(pointData);
      }

      return Promise.resolve(null);
    }
  }

  class Popup extends google.maps.OverlayView {
    position: google.maps.LatLng;
    content: HTMLElement;
    anchor: HTMLElement;
    close: HTMLElement;
    events: string[] = ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart', 'pointerdown'];
    stopPropagationHandler: EventListenerOrEventListenerObject;

    constructor(position: google.maps.LatLng, type: number, callback: Promise<MapPointData>) {
      super();
      this.position = position;

      this.content = document.createElement('div');
      this.content.classList.add('cms-dumel-map__popup-content');
      this.content.classList.add('cms-dumel-map__popup-content--type-' + type);

      this.close = document.createElement('div');
      this.close.classList.add('cms-dumel-map__popup-close');
      this.content.appendChild(this.close);

      this.anchor = document.createElement('div');
      this.anchor.classList.add('cms-dumel-map__popup');
      this.anchor.appendChild(this.content);

      this.stopPropagationHandler = (e) => {
        e.stopPropagation();
      };

      callback.then((data: any) => {
        const value: MapPointData = data;

        if (!value) {
          return;
        }

        const openClosedWeek = value.OpenFromWeek && value.OpenToWeek ? `<div class='cms-dumel-map__popup-content-text'>
          Pon - Pt: ${value.OpenFromWeek} - ${value.OpenToWeek}
        </div>` : '';

        const openClosedSat = value.OpenFromSat && value.OpenToSat ? `<div class='cms-dumel-map__popup-content-text'>
          Sobota: ${value.OpenFromSat} - ${value.OpenToSat}
        </div>` : '';

        const openClosedSun = value.OpenFromSun && value.OpenToSun ? `<div class='cms-dumel-map__popup-content-text'>
          Niedziela: ${value.OpenFromSun} - ${value.OpenToSun}
        </div>` : '';

        const phone = value.Phone ? `<div class='cms-dumel-map__popup-content-text'>
          Telefon: <a target="_blank" class='cms-dumel-map__popup-content-text-link' href="tel:${value.Phone}" rel="nofollow">${value.Phone}</a>
        </div>` : '';

        const email = value.Email ? `<div class='cms-dumel-map__popup-content-text'>
          E-mail: <a target="_blank" class='cms-dumel-map__popup-content-text-link' href="tel:${value.Email}" rel="nofollow">${value.Email}</a>
        </div>` : '';

        const www = value.WWW ? `<div class='cms-dumel-map__popup-content-text'>
          www: <a target="_blank" class='cms-dumel-map__popup-content-text-link' href="${value.WWW}" rel="nofollow">${value.WWW}</a>
        </div>` : '';

        $(this.anchor).find('.cms-dumel-map__popup-content').append(`
          <div class='cms-dumel-map__popup-content-title'>${value.Name}</div>
          <div class='cms-dumel-map__popup-content-text'>${value.City}</div>
          <div class='cms-dumel-map__popup-content-text'>${value.Address}</div>
          <!--<div class='cms-dumel-map__popup-content-text cms-dumel-map__popup-content-text--description'>${value.Description}</div>-->
          ${email}${www}${phone}
          <div class='cms-dumel-map__opened-container'>
            ${openClosedWeek}${openClosedSat}${openClosedSun}
          </div>
        `);
      });

      this.registerListeners();
    }

    onAdd() {
      this.getPanes().floatPane.appendChild(this.anchor);

      setTimeout(() => {
        this.anchor.classList.add('cms-dumel-map__popup--opened');
      });
    }

    onRemove() {
      if (this.anchor.parentElement) {
        this.anchor.parentElement.removeChild(this.anchor);
      }

      this.unregisterListeners();
    }

    draw() {
      const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
      this.anchor.style.left = divPosition.x + 'px';
      this.anchor.style.top = divPosition.y + 'px';
    }

    private registerListeners() {
      this.events
        .forEach((event) => {
          this.anchor.addEventListener(event, this.stopPropagationHandler);
        });

      $(this.close).on('click', () => {
        this.setMap(null);
      });

      $('.cms-dumel-map__toggle, .cms-dumel-map-resize.--resize').click(() => {
        this.setMap(null);
      });
    }

    private unregisterListeners() {
      this.events.forEach(event => {
        this.anchor.removeEventListener(event, this.stopPropagationHandler);
      });

      $(this.close).off();
    }
  }

  const map = new DumelMap($('dumel-maps'));

  $('.cms-dumel-map__toggle, .dumel-main-template__shop-button').click(() => {
    map.toggleMap();
  });

  $('.cms-dumel-map__toggle, .cms-dumel-map-resize').click(() => {
    $('.cms-dumel-map').toggleClass('--resize');
    $('.cms-dumel-map-resize').toggleClass('--resize');
    $('.cms-dumel-map__resize--left').toggleClass('--resize');
    $('.cms-dumel-map__resize--right').toggleClass('--resize');
  });
});
